import { Progress } from '@backstage/core-components';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
} from '@material-ui/core';
import { PropsWithChildren } from 'react';
import { objectIsEmpty } from './utils/checks';

interface BaseDialogProps {
  open: boolean;
  handleClose: () => void;
  handleConfirm: (e: any) => void;
  disableConfirm: boolean;
  isLoading: boolean;
  title: string;
  apiValidationPayload?: any;
}

export const BaseDialog = ({
  open,
  handleClose,
  handleConfirm,
  isLoading,
  disableConfirm,
  title,
  apiValidationPayload,
  children,
}: PropsWithChildren<BaseDialogProps>) => {
  return (
    <Dialog open={open} maxWidth="md" onClose={handleClose}>
      <form onSubmit={handleConfirm} autoComplete="off">
        <DialogTitle>{title}</DialogTitle>
        <Divider variant="middle" />
        <DialogContent>{children}</DialogContent>
        <DialogActions>
          {isLoading ? (
            <div>
              loading... <Progress />
            </div>
          ) : (
            <></>
          )}
          <Button onClick={handleClose} color="primary" disabled={isLoading}>
            Cancel
          </Button>
          <Button
            disabled={
              isLoading ||
              disableConfirm ||
              !objectIsEmpty(apiValidationPayload?.form.formState.errors)
            }
            type="submit"
            color="primary"
          >
            Confirm
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
